import { localDate } from '@/platform/lib/utils';
import { useConfirmationStore } from '@/platform/stores/useConfirmationStore';
import { Button, Tooltip, TooltipContent, TooltipTrigger } from '@/platform/ui';
import { CheckIcon } from '@heroicons/react/24/outline';
import { router, usePage } from '@inertiajs/react';

const ConfirmDecline = ({ entitlement }) => {
    const { auth } = usePage().props;
    const confirm = useConfirmationStore(state => state.confirm);

    const confirmRemoval = () => {
        confirm({
            description:
                'Wil je bevestigen dat deze LKV-aanspraak verwijderd mag worden? Dit kan niet ongedaan worden gemaakt.',
            onConfirm: close => {
                router.post(
                    `/customers/${auth?.user?.selected_customer_id}/services/lkv/${entitlement.id}/decline`,
                    {},
                    {
                        preserveScroll: true,
                        preserveState: true,
                        onFinish: close,
                    }
                );
            },
        });
    };

    if (entitlement.decline_confirmed_at) {
        return <span>{localDate(entitlement.decline_confirmed_at)}</span>;
    }

    return (
        <Tooltip>
            <TooltipTrigger>
                <Button
                    variant='danger'
                    onClick={() => confirmRemoval(entitlement)}
                >
                    <CheckIcon className='size-4' />
                </Button>
            </TooltipTrigger>
            <TooltipContent>
                Bevestigen dat deze aanspraak verwijderd mag worden.
            </TooltipContent>
        </Tooltip>
    );
};

export default ConfirmDecline;
